<template>
  <div class="leo2-app-home">
    <div class="logo-div">
      <div class="logo-left">
        <img src="../assets/imagesMobile/logo_v1.png" alt="" />
        <span class="logo-text">玩得赚</span>
      </div>
      <div class="logo-right">
        <div class="logo-right-btn" @click="startMake(true)">立即试玩</div>
      </div>
    </div>
    <div class="app-content">
      <div class="app-home-tip">
        <img src="/static/images/mobile/tip_bg2@x2.png" />
        <!-- <div class="app-home-tip-text">
          <span class="tip-text-black">新人加入，</span>
          <span class="tip-text-red">立享红包</span>
          <span class="tip-text-black">，秒到账</span>
        </div> -->
      </div>
      <div class="app-home-btn">
        <div @click="startMake(true)">
          <!-- <img src="../assets/imagesMobile/btn_bg.png" alt="Background" /> -->
          <span class="app-home-btn-text">开始试玩</span>
        </div>
        <!-- <div @click="startMake(true)" ref="jsonAni"></div> -->
      </div>
    </div>
    <div class="mask" v-if="browser.wechat || browser.qq" @click="closeMask()">
      <img v-if="browser.android" src="../assets/images/guide_android.png" />
      <img v-if="browser.ios" src="../assets/images/guide_ios.png" />
    </div>
    <div
      class="mask-layer"
      v-if="browser.wechat || browser.qq"
      @click="closeMask()"
    ></div>
  </div>
</template>

<script>
import { utils } from "../utils";
import { BaseUrl } from "../utils/config.js";
import lottie from "lottie-web";
import installJson from "@/assets/json/other/btn.json";
export default {
  name: "index",
  data() {
    return {
      install: {},
      isAndroid: false,
      isIos: false,
      downloadUrl: {},
      isDisabled: false,
      browser: {},
    };
  },
  mounted() {
    this.browser = utils.Browser;
    if (this.browser.wechat || this.browser.qq) {
      document.title = "";
    } else {
      document.title = "玩得赚 - 一个创造价值的试玩APP";
    }
    this.init();
    this.$nextTick(() => {
      // if (this.$refs.jsonAni) {
      //   lottie.loadAnimation({
      //     container: this.$refs.jsonAni,
      //     renderer: "svg",
      //     loop: true,
      //     autoplay: true,
      //     animationData: installJson,
      //   });
      // }
    });
  },
  methods: {
    init() {
      this.axios.install().then((res) => {
        this.install = res.data.data;
        if (
          parent.frames.length > 0 &&
          this.install.download_type == 1 &&
          this.install.payload_type == 2
        ) {
          //通知上级设置添加主屏幕json
          window.top.postMessage({ cmd: "install", data: res.data.data }, "*");
        } else if (
          parent.frames.length > 0 &&
          this.install.download_type == 0 &&
          this.install.payload_type == 2
        ) {
          //下载方式已改变,通知上级重新加载界面
          window.top.postMessage(
            { cmd: "reload", url: window.location.href },
            "*",
          );
        }
      });
    },
    goPage() {
      this.$router.push({
        path: "/news",
      });
    },
    startMake(bool) {
      const ua = navigator.userAgent.toLowerCase();
      if (utils.Browser.android) {
        // 安卓
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          // 微信
          if (bool) {
            this.isAndroid = true;
          }
        } else {
          this.axios.install().then((res) => {
            this.downloadUrl = res.data.data;
            window.location.href = this.downloadUrl.DownloadUrl;
          });
        }
      } else if (
        utils.Browser.ios ||
        utils.Browser.ipad ||
        utils.Browser.iphone
      ) {
        if (bool) {
          if (
            ua.match(/MicroMessenger/i) == "micromessenger" ||
            (ua.indexOf(" qq") > -1 && ua.indexOf("mqqbrowser") < 0)
          ) {
            // 微信QQ
            this.$router.push({
              path: "/install",
            });
          } else {
            //添加主屏幕
            window.location.href =
              BaseUrl +
              "ios/wapenter?url=" +
              window.location.href +
              "&t=" +
              new Date().getTime();
          }
        }
      }
    },
    closeMask() {
      // 关闭提示
      this.isAndroid = false;
      this.isIos = false;
    },
  },
};
</script>

<style scoped lang="scss">
.leo2-app-home {
  max-width: 750px;
  height: auto;
  margin: 0 auto;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;

  .app-content {
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: absolute;
    top: 54px;
    bottom: 0;
    background: #FF462C url("../assets/imagesMobile/pic_v1.png?v=1") no-repeat
      top;
    background-size: 100% auto;
    .news {
      float: right;
      width: 90px;
      height: 27px;
      line-height: 27px;
      text-align: center;
      background-color: #ffa16b;
      margin-top: 35px;
      color: #f44336;
      font-size: 13px;
      border-top-left-radius: 27px;
      border-bottom-left-radius: 27px;
      cursor: pointer;
    }

    .app-home-tip {
      position: absolute;
      bottom: 100px;
      left: 0;
      width: 100%;
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: center;
      // position: relative; // 添加：作为子元素绝对定位的参考

      img {
        width: 238px;
        height: 56px;
      }

      .app-home-tip-text {
        position: absolute; // 添加：绝对定位
        top: 55%; // 添加：垂直居中
        left: 50%; // 添加：水平居中
        transform: translate(-50%, -50%); // 添加：精确居中
        z-index: 10; // 添加：确保在图片上层
        display: flex; // 添加：让内部 span 横向排列
        align-items: center;

        .tip-text-black {
          height: 20px;
          font-weight: bolder;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          white-space: nowrap;
        }
        .tip-text-red {
          height: 20px;
          font-weight: bolder;
          font-size: 14px;
          color: #ff0000;
          line-height: 20px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          white-space: nowrap;
        }
      }
    }

    @keyframes pulse {
      0%,
      100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.1);
      }
    }

    .app-home-btn {
      position: absolute;
      bottom: 30px;
      left: 0;
      width: 100%;
      height: 58px;
      display: flex;
      align-items: center;
      justify-content: center;
      div {
        width: 249px;
        height: 73px;
        animation: pulse 1.5s ease-in-out infinite;

        /* 1. 设置图片路径 */
        background-image: url("../assets/imagesMobile/btn_bg.png");

        /* 2. 关键：让图片铺满且不变形 (优先推荐 cover) */
        background-size: cover;

        /* 3. 关键：让图片居中显示，避免重要部分被裁切 */
        background-position: center center;

        /* 4. 防止图片平铺重复 */
        background-repeat: no-repeat;

        img {
          width: 259px;
          height: 60px;
          display: block; // 关键：让 transform 生效
        }

        .app-home-btn-text {
          position: absolute; // 绝对定位
          top: 50%; // 垂直居中
          left: 50%; // 水平居中
          transform: translate(-50%, -50%); // 精确居中
          font-weight: bolder;
          font-size: 29px;
          z-index: 10; // 确保在图片上层
          color: #ffffff;
          line-height: 37px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          white-space: nowrap; // 不换行
          pointer-events: none; // 点击事件穿透到下层 div
        }
      }
    }
  }

  .logo-div {
    width: 100%;
    // max-width: 750px;
    height: 54px;
    background-color: #fff;
    display: flex;
    justify-content: space-between; // 两端对齐
    align-items: center; // 垂直居中

    .logo-left {
      display: flex;
      margin-left: 20px;
      align-items: center; // 内部垂直居中
      img {
        width: 38px;
        height: 38px;
      }
      .logo-text {
        padding-left: 6px;
        height: 18px;
        font-weight: 600;
        font-size: 18px;
        color: #444444;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
    .logo-right {
      width: 88px;
      height: 26px;
      margin-right: 20px;
      // padding-right: 40px;
      background: linear-gradient( 270deg, #55B2FF 0%, #5E79FA 100%);
      border-radius: 13px;
      display: flex;
      align-items: center; // 内部垂直居中
      justify-content: center; // 内部水平居中

      .logo-right-btn {
        height: 18px;
        font-weight: bolder;
        font-size: 14px;
        color: #ffffff;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }
  .mask {
    width: 375px;
    position: absolute;
    right: 4px;
    top: 10px;
    z-index: 10000;

    img {
      width: 375px;
    }
  }

  .mask-layer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f44336;
    // opacity: 0.7;
    z-index: 1000;
  }
}
</style>
